import type { TFunction } from 'i18next'
import type { StoredUsers } from '~/gql/users/users'
import { roleLabel } from '~/helpers/users/role-label'
import { lastConnectionLabel } from '~/pages/backoffice/admin/user/list/last-connection'

/** En-têtes de l'export CSV de la liste des comptes. */
export function usersCsvHeaders(t: TFunction): string[] {
  return [
    t('common.email'),
    t('common.username'),
    t('common.firstname'),
    t('common.lastname'),
    t('user.company'),
    t('user.department'),
    t('common.role'),
    t('common.groups'),
    t('common.lastConnection'),
  ]
}

/**
 * Une ligne de l'export : les mêmes valeurs que l'écran. Il servait autrefois
 * `updatedAt` sous l'intitulé « dernière connexion », donc une date de
 * modification de fiche présentée comme une connexion.
 */
export function usersCsvRow(t: TFunction, locale: string, user: StoredUsers): string[] {
  return [
    user.email ?? '',
    user.username ?? '',
    user.firstName,
    user.lastName,
    user.company ?? '',
    user.department ?? '',
    roleLabel(t, user.role.name),
    (user.groups ?? []).map(g => g.name).join(', '),
    lastConnectionLabel(t, locale, user),
  ]
}
